export enum GenerativeUserFeedbackType {
  challengeDescription = 'challenge_description',
  challengeObjective = 'challenge_objective',
  challengeBackground = 'challenge_background',
}

export enum GenerativeType {
  challengeDescription = 'challenge_description',
  challengeObjective = 'challenge_objective',
  challengeBackground = 'challenge_background',
}
